module.exports = __webpack_public_path__ + "media/images/athletes/2510-cfb8030b5fcc09529bccda4998b07bfc.png";